import React from 'react'
import {Button} from 'react-bootstrap'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {resetDefaults, updateUserData} from '../actions'
import api from '../api'
import {DEFAULT_NUMBERS_INITIAL_STATE} from '../reducers'
import * as at from '../actionTypes'

@withRouter
@connect((state) => {
  const {
    app: {isLoggedIn},
    userData: {userId},
  } = state

  return {
    isLoggedIn,
    userId,
  }
})
@api
export default class ResetDefaults extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      is_resetting: false,
      error_response: '',
    }
    this.handleReset = this.handleReset.bind(this)
  }

  handleReset(event) {
    this.setState({error_response: ''})
    const {dispatch, apiInstance, history, isLoggedIn, userId} = this.props

    if (isLoggedIn) {
      this.setState({is_resetting: true})
      var initialDefaultNumbers = JSON.parse(
        JSON.stringify(DEFAULT_NUMBERS_INITIAL_STATE),
      )

      initialDefaultNumbers.userId = userId
      apiInstance
        .post('savedefaultnumbers', initialDefaultNumbers)
        .then((response) => {
          this.setState({is_resetting: false})
          if (response) {
            if (response.status === at.API_OK) {
              dispatch(updateUserData(response.data))
              window.alert(`Default Numbers have been reset!`)
              history.push('/')
              return
            } else {
              console.log(
                'Error resetting default numbers to server',
                response.msg,
              )
            }
          }
          console.log('Error resetting default numbers to server! No Response!')
          window.alert('Failed to reset default numbers!')
        })
        .catch((err) => {
          this.setState({is_resetting: false})
          console.log('Error resetting default numbers to server', err)
          window.alert('Error Connecting to server!')
        })
    } else {
      dispatch(resetDefaults())
      history.push('/')
    }
  }

  render() {
    const {is_resetting} = this.state
    const {history} = this.props

    return (
      <div className="col-md-12 text-center reset-default-container">
        <form className="modal-dialog" name="form" onSubmit={this.handleReset}>
          <div className="col-md-12">
            <h2 className="modal-title">Reset Default Numbers</h2>
          </div>
          <div className="modal-body">
            <p>Are you sure you want to reset your defaults?</p>
          </div>
          <div className="row">
            <Button
              className="btn cfxpro__btn-default"
              type="submit"
              disabled={is_resetting}
            >
              {is_resetting ? (
                <div>
                  <i className="fa fa-spinner fa-spin" /> Resetting
                </div>
              ) : (
                'Yes'
              )}
            </Button>
            <Button
              className="btn cfxpro__btn-secondary space-left"
              onClick={() => history.push('/')}
            >
              No
            </Button>
          </div>
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/resetDefaults.js